// extracted by mini-css-extract-plugin
export default {"showServiceList":"style_showServiceList__cuJd8","title":"style_title__YYuld","body":"style_body__YiCoT","footer":"style_footer__vTUnx","rowRevers":"style_rowRevers__rZqg8"};